import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import WhyPacific from "@/pages/WhyPacific";
import Contact from "@/pages/Contact";
import Drive from "@/pages/Drive";
import Admin from "@/pages/Admin";
import ChatWidget from "@/components/ChatWidget";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <div className="min-h-screen bg-white font-body text-ink antialiased">
                <Header />
                <main id="main-content">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/solutions" element={<Solutions />} />
                        <Route path="/why-pacific" element={<WhyPacific />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/drive" element={<Drive />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <ChatWidget />
                <Toaster position="bottom-right" richColors closeButton />
            </div>
        </BrowserRouter>
    );
}

export default App;
